(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1352],{

/***/ 5650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sections_Hero; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
// EXTERNAL MODULE: ./node_modules/emotion-rgba/dist/index.js
var dist = __webpack_require__(49484);
;// CONCATENATED MODULE: ./components/sections/Hero/hero.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 9.25rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 14rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 22.5rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 1rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 1.25rem;\n    bottom: -2px;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 1.875rem;\n    bottom: 0;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 4.25rem;\n    line-height: 5.125rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 8rem;\n    line-height: 9.25rem;\n    margin-bottom: -1.6875rem;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 13rem;\n    line-height: 15.125rem;\n    margin-bottom: -2.75rem;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}





const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e8sppqh0"
})("position:relative;overflow:hidden;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";min-height:6rem;", mixins.mq.xSmall((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";");
const Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e8sppqh1"
})(mixins/* defaultContainerSize */.sX, ";height:100%;display:flex;min-height:inherit;justify-content:flex-start;align-items:flex-end;");
const HeroBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("hr", {
    target: "e8sppqh2"
})("position:absolute;width:100vw;bottom:0;left:0;margin:0;border:none;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";height:0.5rem;", mixins.mq.xSmall((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", {
    target: "e8sppqh3"
})("font-size:3.25rem;line-height:4rem;font-weight:400;letter-spacing:0.0375rem;background:linear-gradient(90deg,#584ca9 0%,#be4969 100%);background-clip:text;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";color:", (0,dist.rgba)(theme/* THEME.colors.core_white */.C.colors.core_white, 0), ";position:relative;user-select:none;margin:0 0 -0.6875rem 0;", mixins.mq.xSmall((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), ";");

;// CONCATENATED MODULE: ./components/sections/Hero/Hero.tsx



const Hero = (param)=>{
    let { title , lottieProps  } = param;
    const ref = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        __webpack_require__.e(/* import() */ 1807).then(__webpack_require__.bind(__webpack_require__, 70886));
        return ()=>{
            var _ref_current, _ref_current__lottie;
            (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : (_ref_current__lottie = _ref_current._lottie) === null || _ref_current__lottie === void 0 ? void 0 : _ref_current__lottie.destroy();
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        children: title
                    }),
                    lottieProps && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("lottie-player", {
                        ref: ref,
                        autoplay: true,
                        mode: "normal",
                        class: "hero__lottie",
                        ...lottieProps
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroBlock, {})
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/Hero/index.ts

/* harmony default export */ var sections_Hero = (Hero);


/***/ }),

/***/ 21488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sections_SectionDescriptionWithImage; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./components/sections/SectionDescriptionWithImage/sectionDescriptionWithImage.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n    justify-content: space-between;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        ";\n    flex-direction: row;\n    padding-top: 7.5rem;\n    padding-bottom: 7.5rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 29.1875rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 33.5rem;\n    line-height: 3.5rem;\n    letter-spacing: -0.0125rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 29.1875rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 36rem;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        position: absolute;\n      "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        "\n      right: 0;\n      bottom: 0;\n    "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 26.625rem;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 31.25rem;\n    height: 100%;\n    align-items: flex-end;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}




const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "eqe41ji0"
})("position:relative;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject())));
const Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqe41ji1"
})(mixins/* defaultContainerSize */.sX, ";display:flex;flex-direction:column;gap:4rem;justify-content:space-between;padding-top:2rem;padding-bottom:0;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), mixins/* defaultContainerSize */.sX)));
const TextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqe41ji2"
})("display:flex;flex-direction:column;justify-content:center;");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", {
    target: "eqe41ji3"
})(Typography/* Headline1 */.iH, ";max-width:21.4375rem;text-align:left;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";margin:0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), " ", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())));
const Subtitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "eqe41ji4"
})(Typography/* Headline1 */.iH, ";margin:0;text-align:left;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";");
const Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "eqe41ji5"
})(Typography/* ParagraphS */.fw, ";letter-spacing:0.0125rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";margin:2rem 0 0 0;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), " ", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())));
const Image = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqe41ji6"
})("position:relative;width:100%;height:auto;min-height:20.375rem;max-width:23rem;align-self:flex-end;", (param)=>{
    let { isImageToRight  } = param;
    return isImageToRight && (0,emotion_react_browser_esm/* css */.iv)(_templateObject7(), mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())));
}, " ", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), " ", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject9())), "  \n  img{width:100%;height:100%;max-height:27.563rem;inset:inherit;}");

// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/sections/SectionDescriptionWithImage/SectionDescriptionWithImage.tsx





const SectionDescriptionWithImage = (param)=>{
    let { title , description , image , subtitle , isImageToRight =false , titleAs  } = param;
    const sectionRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        ref: sectionRef,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextWrapper, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                            as: titleAs,
                            children: title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subtitle, {
                            as: titleAs,
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
                    isImageToRight: isImageToRight,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        ...(0,imageSerializer/* imageSerializer */.l)(image, {
                            layout: "fill"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/SectionDescriptionWithImage/index.ts

/* harmony default export */ var sections_SectionDescriptionWithImage = (SectionDescriptionWithImage);


/***/ }),

/***/ 79794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ TitleAs; }
/* harmony export */ });
var TitleAs;
(function(TitleAs) {
    TitleAs["h1"] = "h1";
    TitleAs["h2"] = "h2";
    TitleAs["h3"] = "h3";
    TitleAs["h4"] = "h4";
    TitleAs["h5"] = "h5";
    TitleAs["h6"] = "h6";
})(TitleAs || (TitleAs = {}));


/***/ }),

/***/ 37645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 33644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _loadableContext = __webpack_require__(33644);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(37645)


/***/ })

}]);